import { render } from "./Prologue2024Template.vue?vue&type=template&id=4dcb11e9&scoped=true&ts=true"
import script from "./Prologue2024Template.vue?vue&type=script&lang=ts"
export * from "./Prologue2024Template.vue?vue&type=script&lang=ts"

import "./Prologue2024Template.vue?vue&type=style&index=0&id=4dcb11e9&lang=scss&scoped=true"

import exportComponent from "/Users/hirosuke-pi/projects/vr-jmof-front-2020/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dcb11e9"]])

export default __exports__